"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connector = void 0;
const PortContract_1 = require("./PortContract");
/**
 * Connector — the assembly connector in UML component diagrams.
 *
 * Links a required port (socket) on one component to a provided port
 * (lollipop) on another component, satisfying the declared dependency.
 *
 * Assembly files (AppConnectorAssembly, InfraConnectorAssembly,
 * ConnectorAssembly) create one Connector per interface and call assemble()
 * to wire the graph at startup.
 *
 * Usage:
 *   new Connector<IPlayerRepository>('PlayerRepository')
 *     .assemble(app.playerRepositoryPort, infra.playerRepositoryPort);
 */
class Connector {
    label;
    constructor(label) {
        this.label = label;
    }
    /**
     * Wire the socket to the lollipop, refusing a label that names neither.
     *
     * ⚠ THE LABEL WAS WRITE-ONLY UNTIL 2026-09-09, AND THAT MADE THIS CLASS CEREMONY. It was assigned
     * in the constructor and read NOWHERE in the repository — so a port name existed in three places
     * (socket, lollipop, connector label) with nothing checking that the three agreed. A connector
     * labelled 'GetRoom' could wire `roomSavePort` to `playerSavePort` and every gate stayed green,
     * because the diagram is drawn from the PORT names and never sees this one. The only thing
     * `Connector<T>` bought over a bare `socket.connect(lollipop)` was the shared `T`, which
     * `connect()`'s own signature already provides.
     *
     * Checking the label is what makes it mean something. The socket↔lollipop half of the agreement is
     * enforced one level down, by `RequiredPort.connect()`, so this method asserts only the part that
     * is this class's own: that the label a reader of the assembly file sees names the port actually
     * being wired.
     */
    assemble(required, provided, observer = PortContract_1.NO_OBSERVER) {
        if (this.label !== required.name) {
            throw new Error(`Connector '${this.label}' was asked to assemble required port '${required.name}'. The ` +
                'label is what a reader of the assembly file believes is being wired; a label that names a ' +
                'different port is a comment that disagrees with its own code.');
        }
        // The observer is the composition root's, handed in here because assembly is the one moment
        // that knows both the port and the process it runs in. Name and digest agreement are checked
        // one level down, in connect().
        required.connect(provided, observer);
    }
}
exports.Connector = Connector;
//# sourceMappingURL=Connector.js.map